import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiX } = FiIcons;

const ExitPopup = ({ show, onClose }) => {
  return (
    <AnimatePresence>
      {show && (
        <motion.div
          className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50 flex items-center justify-center p-4"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
        >
          <motion.div
            className="bg-white rounded-3xl p-8 max-w-md w-full text-center relative"
            initial={{ scale: 0.5, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.5, opacity: 0 }}
          >
            <button
              onClick={onClose}
              className="absolute top-4 right-4 p-2 hover:bg-gray-100 rounded-full"
            >
              <SafeIcon icon={FiX} className="w-5 h-5" />
            </button>

            <div className="text-6xl mb-4">⏰</div>
            <h3 className="text-2xl font-bold text-gray-800 mb-4">
              Wait! Don't Miss Out!
            </h3>
            <p className="text-gray-600 mb-6">
              Keep all the bonuses worth ₹25,495 and grab the complete Diwali success package for just ₹97!
            </p>
            
            <div className="space-y-3">
              <button 
                onClick={() => {
                  document.getElementById('checkout')?.scrollIntoView({ behavior: 'smooth' });
                  onClose();
                }}
                className="glow-button text-white px-8 py-3 rounded-xl font-bold w-full"
              >
                🔥 Yes! I Want the Deal
              </button>
              <button 
                onClick={onClose}
                className="text-gray-500 hover:text-gray-700 transition-colors"
              >
                No thanks, I'll pass
              </button>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default ExitPopup;